<template>
	<div class="forgotpassword">
        <b-container>
            <b-row class="mb-4">
                <b-col class="text-center mb-4">
                    <b-link href="/"><b-img :src="$root.MEDIAPATH+'images/logo.png'" class="logo"></b-img>	</b-link>
                </b-col>
            </b-row>
			<b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg!=''">{{error_msg}}</b-alert></b-row>
			<b-row align-h="center">
				<b-col cols="12" lg="4" md="4" sm="12" class="panel">
					
					<div v-if="otpgenerated=='nootp'">
                    <form  ref="form" @submit.stop.prevent="handleSubmit">
						<p style="text-align:center;" >
							<span>Password Reset</span>
							<br/>
							<small>
								Enter the email address or mobile phone number associated with your Alluraa account.
							</small>
						</p>
					
					
						<b-form-group label-for="email-input" label-size="sm" label-class="mb-0" class="mb-4" :state="registerState.email" :invalid-feedback="registerError.email"  label="Email or mobile phone number" >
							<b-form-input id="email-input" :state="registerState.email" v-model="register.email" @focusin="registerState.email = null,error_msg=''" size="sm"></b-form-input>
							</b-form-group>
					
					
                       
                        <b-button type="submit" variant="primary"  class="btn-solid btn2 btnFor">Proceed</b-button>
                        
                        
                    </form>
					</div>
					<div v-if="otpgenerated=='yes'">
						<form  ref="formd" @submit.stop.prevent="handleSubmitOTP">
							<p>
								<small>For your security, we need to authenticate your request. We've sent a CODE to the email <strong>{{register.email}}</strong> . Please enter it below to complete verification.</small>
								<br/><small>(Be sure to check your spam folder)</small></p>
								<b-row class="mb-4">
									<b-col cols="6">
									<b-form-group label-for="Otp-input" label-size="sm" label-class="mb-0" class="mb-1" :state="registerState.otp" :invalid-feedback="registerError.otp"  label="Enter CODE" >
									<b-form-input id="Otp-input" :state="registerState.otp" v-model="register.otp" @focusin="registerState.otp = null,error_msg=''" size="sm"></b-form-input>
									</b-form-group>
									</b-col>
									<b-col class="mt-32">
									
									<b-link class="btnResend" @click="handleSubmit(),resendCode=1">Re-Send CODE</b-link>
							
									</b-col>
								</b-row>
							<b-row>
								<b-col class="align-center">
								<b-button type="submit" variant="primary"  class="btn-solid btn2 btnFor">Verify</b-button>
								</b-col>
							</b-row>
							
						</form>
					</div>
					<div v-if="otpgenerated=='new'">
						<form  ref="formcp" @submit.stop.prevent="handleSubmitChangpassword">
								<p style="text-align:center;" >
									<span>Create new password</span>
									<br/>
									<small>
										We'll ask for this password whenever you sign in.
									</small>
								</p>
							
								<b-row class="mb-4">
									<b-col >
									<!-- <b-form-group label-for="Otp-input" label-size="sm" label-class="mb-0" class="mb-1" :state="registerState.otp" :invalid-feedback="registerError.otp"  label="Enter CODE" >
									<b-form-input id="Otp-input" :state="registerState.otp" v-model="register.otp" @focusin="registerState.otp = null,error_msg=''" size="sm"></b-form-input>
									</b-form-group>-->
									
									<b-form-group :state="registerState.new_password" label="New Password" label-size="sm" label-for="fpassword-input" :invalid-feedback="registerError.new_password"  label-class="mb-0" class="mb-1" >
									<b-form-input type="password" id="fpassword-input" v-model="register.new_password"  size="sm" @focusin="registerState.new_password = null,error_msg=''" ></b-form-input>
									</b-form-group>
								
									<b-form-group :state="registerState.conformpassword" label="Confirm password" label-size="sm" label-for="fcpassword-input" :invalid-feedback="registerError.conformpassword"  label-class="mb-0" class="mb-1" >
									<b-form-input type="password" id="fcpassword-input" v-model="register.conformpassword" size="sm" @focusin="registerState.conformpassword = null,error_msg=''" ></b-form-input>
									</b-form-group>
									
									</b-col>
									
								</b-row>
							<b-row>
								<b-col class="align-center">
								<b-button type="submit" variant="primary"  class="btn-solid btn2 btnFor">Save changes and sign in</b-button>
								</b-col>
							</b-row>
							
						</form>
					</div>
                </b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Resetpassword',
	props: {
		//metadata: { type: Object },
	},
	created() {
	},
	beforeCreate: function() {
        //document.body.className = 'homenew'; 
    },
	components: {
	},
	mounted(){
		if(this.$root.customer_info.user_id>0){
		this.$router.push('/');
		}
        //this.initload();
		//this.otpgenerated='nootp';
	},
	data() {
		return{
			
			url: this.$root.WEBURL+'forgotpasswordOtp',
			checkUrlOTP: this.$root.WEBURL+'forgotpasswordOtpChecker',
			checkUrlCP: this.$root.WEBURL+'forgotpasswordChangepassword',
            register: {
                email: '',
				otp:'',
				new_password:'',
				conformpassword:'',
				rowId:'',
				user_id:'',
            },
			registerState:{
				email:null,
				otp:null,
				new_password:null,
				conformpassword:null,
			},
			registerError:{
				email:'Field is required!',
				otp:'CODE is required!',
				new_password:'Please enter password!',
				conformpassword:'Please reenter password!',
			},
			//otpgenerated:'yes',
			//otpgenerated:'new',
			otpgenerated:'nootp',
			error_msg:'',
			resendCode:'',
            
		};
	},
	methods: {
		checkFormValidity() {
            var valid = true;
			var emailValue =this.register.email;
            if(emailValue==''){
				//this.registerError.email='Enter a valid email address!';
                valid = false;
                this.registerState.email = false;
            }else if(isNaN(emailValue)){
				var trstEmail = this.validateEmail(emailValue);
				if(trstEmail){
						this.registerState.email= true;
					}else{
						this.registerError.email='Enter a valid email address!';				
						valid = false;
						this.registerState.email = false;
					}
			
				/*	
				console.log('this is email');
				valid = false;
                this.registerState.email = false;*/
			}else if(!isNaN(emailValue)){
			
				var trst = this.isPhoneValid(emailValue);
				if(trst){
						this.registerState.email= true;
					}else{
						this.registerError.email='Enter a valid phone number!';
				
						valid = false;
						this.registerState.email = false;
					}
				
				
			
				console.log('this is phone');
				/*valid = false;
                this.registerState.email = false;*/
			}else{
               this.registerState.email = false;
            }
            return valid;
        },
		isPhoneValid(iFSCCode) 
			{
				//var regExp = "^[A-Z]{4}[0][A-Z0-9]{6}$";
				var regExp = /^[0-9]{10,11}$/;
				if (iFSCCode.match(regExp)) {
				
				  return true;
				} else {
				  return false;
				}
				
			},
			validateEmail(mail) 
			{
			 if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail))
			  {
				 return true;
			  }
				
				return false;
			},
        
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('register-modal');
        },
        handleSubmit(){
            if (!this.checkFormValidity()) {
                return;
            }
            var self = this;
            

            var o = {
                email: this.register.email,
            }
           
            
			self.axios.post(self.url, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.otpgenerated='yes';
					if(self.resendCode==1){
						self.$bvToast.toast('Re-Send new CODE. Please check your email!', {
							title: 'Register',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'success',
							solid: true,
							appendToast: true
						}); 
						self.resendCode='';
					}
					//self.$root.flash_msg.msg = response.data.message;
                   
				}else if(response.data.error == 2 || response.data.error == '2'){
					self.error_msg = response.data.message;
                    self.$bvToast.toast(response.data.message, {
						title: 'Forgotpassword',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				
				}else{
					
                    //self.error_msg = response.data.message;
                    self.$bvToast.toast(response.data.message, {
						title: 'Forgotpassword',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		checkFormOtp(){
		 var valid = true;
			var otpValue =this.register.otp;
            if(otpValue==''){				
                valid = false;
                this.registerState.otp = false;
            }else{
				this.registerState.otp = true;
            }
            return valid;
		
		
		},		
		handleSubmitOTP(){
            if (!this.checkFormOtp()) {
                return;
            }
            var self = this;
            

            var o = {
                email: this.register.email,
                otp: this.register.otp,
            }
           
            
			self.axios.post(self.checkUrlOTP, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.otpgenerated='new';
					self.register.rowId = response.data.result.id;
					self.register.user_id = response.data.result.user_id;
					
					/*self.$bvToast.toast(response.data.message, {
						title: 'Register',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
					}); */
					//self.$root.flash_msg.msg = response.data.message;
                   
				}else{
					
                    self.error_msg = response.data.message;
                    self.$bvToast.toast(response.data.message, {
						title: 'Forgotpassword',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		checkFormewpassword(){
			 var valid = true;
			var passwordval =this.register.new_password;
			
            if(this.register.new_password==''){
				this.registerError.new_password='Please enter password!';
                valid = false;
                this.registerState.new_password = false; 
            }else if(this.register.new_password.length < 6){
				this.registerError.new_password='Password should be 6-12 characters long!';
                valid = false;
                this.registerState.new_password = false;
			
			}else{
			this.registerState.new_password = true;
			}
			
			if(this.register.conformpassword.length <1){
					this.registerError.conformpassword='Please enter confirm password!';
					valid = false;
					this.registerState.conformpassword = false;
				
			}else if(passwordval!=this.register.conformpassword){
					this.registerError.conformpassword='Password  and confirm password  is not identical';
					valid = false;
					this.registerState.conformpassword = false;
				
				}else{
				
				
				this.registerState.conformpassword = true;
				}
            return valid;
		
		},
		handleSubmitChangpassword(){
            if (!this.checkFormewpassword()) {
                return;
            }
            var self = this;
            

            var o = self.register;
           
            
			self.axios.post(self.checkUrlCP, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					
					self.$bvToast.toast(response.data.message, {
						title: 'Register',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
					}); 
					self.$router.push('/');
					//self.$root.flash_msg.msg = response.data.message;
                   
				}else{
					
                    self.error_msg = response.data.message;
                    self.$bvToast.toast(response.data.message, {
						title: 'Forgotpassword',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				}
			})
			.catch(function (error) {
				alert(error);
			});
		}
	},
	metaInfo() {
		return{
			title: 'forgotpassword | Alluraa',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa, alluraa register' },
				{ name: 'description', content: 'forgotpassword | Alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
}
</script>
<!--<style scoped lang="scss"> -->
<style  scoped lang="scss">
	.homenew{
		background:#a63aea;
	}
	.forgotpassword{
		.panel{
			border: 1px solid #c6c6c6;
			padding: 33px;
			border-radius: 5px;
			background:#fff;
		}
		.btnFor{ 
		
			width:100%;
			text-align:center;
			padding:10px;
			text-transform: uppercase;
			
		}
		.btnResend{
		color: #c53737;
		background: #c6c6c62e;
		padding: 5px;
		border-radius: 5px;
		font-size: 15px;
		}
		.mt-32{ margin-top:32px;}
		
		.logo{background: #c85df7;
			padding: 5px;
			border: 1px solid #c6c6c6;}
	}
</style>
